document.addEventListener("DOMContentLoaded", function () {

  /* ------------------------------
     SHORT DESCRIPTION EXPAND
  --------------------------------*/
  document.querySelectorAll(".product-short-description").forEach(function (wrapper) {
    wrapper.addEventListener("click", function () {
      wrapper.classList.toggle("expanded");
    });
  });

  /* ------------------------------
     PRODUCT JSON
  --------------------------------*/
  const jsonEl = document.getElementById("ProductJson");
  if (!jsonEl) return;

  const productData = JSON.parse(jsonEl.textContent);

  const variantIdInput = document.getElementById("variantId");
  const totalElement   = document.getElementById("dynamicTotal");
  const priceEl        = document.getElementById("productPrice");
  const atcButton      = document.querySelector(".product-add-to-cart");
  const mainImage      = document.querySelector(".product-main-image img");

  let currentVariant =
    productData.variants.find(function (v) {
      return variantIdInput && String(v.id) === String(variantIdInput.value);
    }) || productData.variants[0];

  let basePrice = currentVariant.price / 100;

  /* configured add-to-cart label (fallback if first variant is sold out) */
  const addLabel =
    atcButton && currentVariant.available ? atcButton.textContent.trim() : "Add to Cart";

  function formatMoney(value) {
    return "$" + value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ------------------------------
     PRICE / COMPARE-AT / LIVE REGION (built at runtime, no template edit)
  --------------------------------*/
  let curEl, cmpEl, saveEl, liveEl;
  if (priceEl) {
    priceEl.innerHTML =
      '<span class="pg-price-current"></span>' +
      '<span class="pg-price-compare" hidden></span>' +
      '<span class="pg-price-save" hidden></span>';
    curEl  = priceEl.querySelector(".pg-price-current");
    cmpEl  = priceEl.querySelector(".pg-price-compare");
    saveEl = priceEl.querySelector(".pg-price-save");

    cmpEl.style.cssText  = "text-decoration:line-through;color:#888;margin-left:10px;font-weight:400;font-size:0.8em;";
    saveEl.style.cssText = "margin-left:10px;color:#41617A;font-weight:600;font-size:0.7em;";

    liveEl = document.createElement("span");
    liveEl.className = "visually-hidden";
    liveEl.setAttribute("aria-live", "polite");
    priceEl.insertAdjacentElement("afterend", liveEl);
  }

  function renderPrice(variant) {
    if (!priceEl) return;
    const price   = variant.price / 100;
    const compare = variant.compare_at_price ? variant.compare_at_price / 100 : 0;
    curEl.textContent = formatMoney(price);
    if (compare > price) {
      cmpEl.textContent = formatMoney(compare);
      cmpEl.hidden = false;
      const pct = Math.round(((compare - price) / compare) * 100);
      saveEl.textContent = "Save " + formatMoney(compare - price) + " (" + pct + "%)";
      saveEl.hidden = false;
      priceEl.classList.add("on-sale");
    } else {
      cmpEl.hidden = true;
      saveEl.hidden = true;
      priceEl.classList.remove("on-sale");
    }
  }

  function renderAtc(variant) {
    if (!atcButton) return;
    if (variant.available) {
      atcButton.disabled = false;
      atcButton.textContent = addLabel;
    } else {
      atcButton.disabled = true;
      atcButton.textContent = "Sold Out";
    }
  }

  function announce(variant) {
    if (!liveEl) return;
    liveEl.textContent = (variant.available ? "" : "Sold out. ") + formatMoney(variant.price / 100);
  }

  function pushHistory(variant) {
    if (!history.replaceState) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      history.replaceState({ variant: variant.id }, "", url.toString());
    } catch (e) {}
  }

  /* ------------------------------
     DESKTOP THUMBNAIL GALLERY
  --------------------------------*/
  const thumbs = document.querySelectorAll(".thumb-image");
  thumbs.forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      if (!mainImage) return;
      const full = thumb.dataset.full;
      if (full) {
        mainImage.src = full;
        mainImage.srcset = thumb.dataset.srcset || "";
      }
      thumbs.forEach(function (t) { t.classList.remove("active"); });
      thumb.classList.add("active");
    });
  });

  /* ------------------------------
     VARIANT SWITCHING
  --------------------------------*/
  const variantButtons = document.querySelectorAll(".variant-btn");
  let selectedOptions = currentVariant.options.slice();

  variantButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (this.disabled) return;
      const optionName = this.dataset.option;
      const wrap = this.closest(".product-variants");
      if (!wrap) return;

      wrap.querySelectorAll('.variant-btn[data-option="' + optionName + '"]').forEach(function (b) {
        b.classList.remove("active");
      });
      this.classList.add("active");

      const groups = [].slice.call(wrap.querySelectorAll(".variant-buttons"));
      const optionIndex = groups.indexOf(this.parentElement);
      selectedOptions[optionIndex] = this.dataset.value;

      updateVariant();
      updateAvailability();
    });
  });

  function updateVariant() {
    const variant = productData.variants.find(function (v) {
      return v.options.every(function (opt, index) {
        return selectedOptions[index] === opt;
      });
    });
    if (!variant) return;

    currentVariant = variant;
    basePrice = variant.price / 100;
    if (variantIdInput) variantIdInput.value = variant.id;

    renderPrice(variant);
    renderAtc(variant);
    announce(variant);
    pushHistory(variant);
    updateTotal();

    if (variant.featured_image && mainImage) {
      mainImage.src = variant.featured_image.src;
      mainImage.srcset = "";
      thumbs.forEach(function (t) { t.classList.remove("active"); });
    }

    syncSticky();
  }

  function updateAvailability() {
    variantButtons.forEach(function (btn) {
      const optionValue = btn.dataset.value;
      const optionIndex = productData.options.indexOf(btn.dataset.option);

      const isAvailable = productData.variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[optionIndex] !== optionValue) return false;
        return selectedOptions.every(function (selected, index) {
          if (index === optionIndex) return true;
          if (!selected) return true;
          return v.options[index] === selected;
        });
      });

      if (isAvailable) {
        btn.classList.remove("sold-out");
        btn.disabled = false;
      } else {
        btn.classList.add("sold-out");
        btn.disabled = true;
      }
    });
  }

  /* ------------------------------
     BUNDLE VARIANT SWITCH
  --------------------------------*/
  document.querySelectorAll(".bundle-item").forEach(function (bundle) {
    const variants = JSON.parse(bundle.dataset.variants);
    const selects  = bundle.querySelectorAll("select");
    const hidden   = bundle.querySelector(".bundle-variant-id");

    function updateBundleVariant() {
      let selected = [];
      selects.forEach(function (select, index) {
        selected[index] = select.value;
      });
      const variant = variants.find(function (v) {
        return v.options.every(function (opt, index) {
          return selected[index] === opt;
        });
      });
      if (!variant || !variant.available) {
        if (hidden) hidden.value = "";
        return;
      }
      if (hidden) hidden.value = variant.id;
      const checkbox = bundle.querySelector(".bundle-checkbox");
      if (checkbox) checkbox.dataset.price = variant.price;
      const priceElB = bundle.querySelector(".bundle-price");
      if (priceElB) priceElB.innerText = "$" + (variant.price / 100).toFixed(2);
    }

    selects.forEach(function (select) {
      select.addEventListener("change", updateBundleVariant);
    });
    updateBundleVariant();
  });

  /* ------------------------------
     BUNDLE + GIFT COLLECTION
  --------------------------------*/
  const bundleCheckboxes = document.querySelectorAll(".bundle-checkbox");

  function getBundleItems() {
    let items = [];
    document.querySelectorAll(".bundle-item").forEach(function (bundle) {
      const checkbox = bundle.querySelector(".bundle-checkbox");
      if (checkbox && checkbox.checked) {
        const hiddenVariant = bundle.querySelector(".bundle-variant-id");
        if (!hiddenVariant || !hiddenVariant.value) return;
        items.push({ id: parseInt(hiddenVariant.value, 10), quantity: 1 });
      }
    });
    return items;
  }

  const giftCheckbox = document.getElementById("giftWrap");
  function getGiftItem() {
    if (giftCheckbox && giftCheckbox.checked) {
      return [{ id: giftCheckbox.dataset.variant, quantity: 1 }];
    }
    return [];
  }

  /* ------------------------------
     DYNAMIC TOTAL
  --------------------------------*/
  function updateTotal() {
    let total = basePrice;
    bundleCheckboxes.forEach(function (box) {
      if (box.checked) total += parseFloat(box.dataset.price) / 100;
    });
    if (giftCheckbox && giftCheckbox.checked) {
      total += parseFloat(giftCheckbox.dataset.price) / 100;
    }
    if (totalElement) totalElement.innerText = formatMoney(total);

    const installmentEl = document.getElementById("installmentPrice");
    if (installmentEl) installmentEl.innerText = formatMoney(total / 4);
  }

  bundleCheckboxes.forEach(function (box) {
    box.addEventListener("change", updateTotal);
  });
  if (giftCheckbox) giftCheckbox.addEventListener("change", updateTotal);

  /* ------------------------------
     ADD TO CART (AJAX, bulk + error handling)
  --------------------------------*/
  function openDrawerSafe() {
    if (typeof window.openCartDrawer === "function") {
      window.openCartDrawer();
    } else {
      window.location.href = "/cart";
    }
  }

  function addItemsToCart(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error((err && err.description) || "This item could not be added to your cart.");
        });
      }
      return res.json();
    });
  }

  const form = document.querySelector(".product-form");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (atcButton && atcButton.disabled) return;

      let items = [{ id: variantIdInput.value, quantity: 1 }];
      items = items.concat(getBundleItems());
      items = items.concat(getGiftItem());

      if (atcButton) {
        atcButton.disabled = true;
        atcButton.textContent = "Adding...";
      }

      addItemsToCart(items)
        .then(function () {
          openDrawerSafe();
        })
        .catch(function (err) {
          window.alert(err.message || "Sorry, this item could not be added to your cart.");
        })
        .then(function () {
          if (atcButton) {
            atcButton.disabled = !currentVariant.available;
            atcButton.textContent = currentVariant.available ? addLabel : "Sold Out";
          }
        });
    });
  }

  /* ------------------------------
     STICKY MOBILE ADD TO CART (mobile only, built at runtime)
  --------------------------------*/
  const stickyStyle = document.createElement("style");
  stickyStyle.textContent =
    ".pg-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:60;background:#fff;" +
    "border-top:1px solid #E8E9EB;box-shadow:0 -6px 18px rgba(61,66,70,.10);" +
    "transform:translateY(100%);transition:transform .22s ease;" +
    "padding-bottom:env(safe-area-inset-bottom);display:none}" +
    ".pg-sticky-atc .pg-sticky-inner{display:flex;align-items:center;gap:10px;padding:10px 12px}" +
    ".pg-sticky-thumb{width:44px;height:44px;border:1px solid #E8E9EB;border-radius:6px;" +
    "object-fit:cover;flex:none;background:#fff}" +
    ".pg-sticky-meta{flex:1;min-width:0;display:flex;flex-direction:column;line-height:1.25}" +
    ".pg-sticky-title{font-size:12px;color:#3D4246;font-weight:500;white-space:nowrap;" +
    "overflow:hidden;text-overflow:ellipsis}" +
    ".pg-sticky-price{font-size:13px;color:#3D4246;font-weight:600}" +
    ".pg-sticky-btn{flex:none;background:#557B97;color:#fff;border:0;border-radius:6px;" +
    "font-family:inherit;font-weight:600;font-size:14px;padding:13px 18px;cursor:pointer}" +
    ".pg-sticky-btn:hover{background:#46667D}" +
    ".pg-sticky-btn:disabled{background:#b6b6ba;cursor:not-allowed}" +
    ".pg-sticky-atc.is-visible{transform:translateY(0)}" +
    "@media (max-width:749px){.pg-sticky-atc{display:block}}";
  document.head.appendChild(stickyStyle);

  const stickyBar = document.createElement("div");
  stickyBar.className = "pg-sticky-atc";
  stickyBar.innerHTML =
    '<div class="pg-sticky-inner">' +
    '<img class="pg-sticky-thumb" alt="" />' +
    '<div class="pg-sticky-meta">' +
    '<span class="pg-sticky-title"></span>' +
    '<span class="pg-sticky-price"></span>' +
    '</div>' +
    '<button type="button" class="pg-sticky-btn">Add to Cart</button>' +
    '</div>';
  document.body.appendChild(stickyBar);

  const sThumb = stickyBar.querySelector(".pg-sticky-thumb");
  const sTitle = stickyBar.querySelector(".pg-sticky-title");
  const sPrice = stickyBar.querySelector(".pg-sticky-price");
  const sBtn   = stickyBar.querySelector(".pg-sticky-btn");

  const stickyTitleSource = document.querySelector(".product-single__title, h1.product-title, .product__title, h1");
  sTitle.textContent = stickyTitleSource ? stickyTitleSource.textContent.trim() : "";

  function stickyImageFor(variant) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (mainImage && mainImage.getAttribute("src")) return mainImage.getAttribute("src");
    return "";
  }

  function syncSticky() {
    sPrice.textContent = formatMoney(currentVariant.price / 100);
    const img = stickyImageFor(currentVariant);
    if (img) sThumb.src = img;
    if (currentVariant.available) {
      sBtn.disabled = false;
      sBtn.textContent = addLabel;
    } else {
      sBtn.disabled = true;
      sBtn.textContent = "Sold Out";
    }
  }

  sBtn.addEventListener("click", function () {
    if (sBtn.disabled) return;
    if (form) {
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      }
    }
  });

  if ("IntersectionObserver" in window && atcButton) {
    const stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove("is-visible");
        } else {
          stickyBar.classList.add("is-visible");
        }
      });
    }, { threshold: 0 });
    stickyObserver.observe(atcButton);
  }

  syncSticky();

  /* ------------------------------
     INITIAL SYNC
  --------------------------------*/
  variantButtons.forEach(function (btn) {
    const idx = productData.options.indexOf(btn.dataset.option);
    if (selectedOptions[idx] === btn.dataset.value) {
      btn.classList.add("active");
    } else {
      btn.classList.remove("active");
    }
  });

  renderPrice(currentVariant);
  renderAtc(currentVariant);
  updateAvailability();
  updateTotal();

});
